import React from 'react';
import { Button } from 'antd';
import CodeMirror from '@uiw/react-codemirror';
import { StreamLanguage } from '@codemirror/language';
import { yaml } from '@codemirror/legacy-modes/mode/yaml';

const codeMirrorBasicSetup = {
  highlightActiveLine: false,
  highlightActiveLineGutter: false,
  highlightSelectionMatches: false,
};

const MappingPresentationPane = ({ onEdit, code, hasPermission }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      justifyContent: 'flex-start',
    }}
  >
    <div className="advanced-mapping">
      <CodeMirror
        value={code || ''}
        extensions={[StreamLanguage.define(yaml)]}
        readOnly
        basicSetup={codeMirrorBasicSetup}
      />
    </div>
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        marginTop: 10,
      }}
    >
      <Button type="primary" disabled={!hasPermission} onClick={() => onEdit(code)}>
        Edit
      </Button>
    </div>
  </div>
);

export default MappingPresentationPane;
